import React, { createRef } from 'react';

/**
 * Initializes a new instance of @type {SearchCenterTile}.
 */
export default class SearchCenterTile extends React.Component {

    /**
     * Initializes a new instance of @type {SearchCenterTile}.
     * @param {Object} props The props JSON.
     */
    constructor(props) {
        super(props);

        /**
         * The max height in px for the center tile snippet. This is assuming purely a line height
         * of 23px for a max of 4 lines.
         * @type {Number}
         */
        this.maxSnippetHeight = 23 * 4; //px
        this.snippetRef = undefined;

        this.state = {
            isTruncated: false
        }
        this.showMore = this.showMore.bind(this);
    }

    /**
     * Set the state based on if the snippet needs to be truncated or not after initial render.
     */
    componentDidMount() {
        this.setState({isTruncated: this.shouldTruncate()});
    }

    /**
     * Gets the snippet HTML block based on the need for truncation and a button to show the rest.
     * @returns The snippet block either with the entire snippet, or the truncated snippet.
     */
    getSnippetBlock() {
        if (!this.state.isTruncated) {
            this.snippetRef = createRef(null);
            return <div className='center-tile__snippet' ref={this.snippetRef} tabIndex='-1'>
                {this.props.snippetContent}
            </div>
        }

        return <div className='center-tile__snippet truncated'>
                {this.props.snippetContent}
                <span className='show-more'>
                    <span className='ellipsis'>&hellip;</span>
                    <a href='#' role='button' title={`Show more about ${this.props.snippetTitle}.`} onClick={this.showMore}>Show More</a>
                </span>
               </div>;
    }

    /**
     * The click event handler for when to show more of the snippet text. Also will refocus
     * a screenreader user on to the snippet div again to read it.
     * @param {Event} e The click or button event. Mostly need to prevent default
     *      with proper roles assigned.
     */
    showMore(e) {
        e.preventDefault();
        this.setState({isTruncated: false}, () => {
            if (this.snippetRef.current) {
                this.snippetRef.current.focus();
            }
        });
    }

    /**
     * Determines if the snippet should be truncated based on initial rendering height
     * and the max allowable height.
     * @returns If the snippet content should be truncated.
     */
    shouldTruncate() {
        return this.snippetRef.current.clientHeight > this.maxSnippetHeight;
    }

    render() {
        return (
            <div className='search__center-tile center-tile message-text' aria-live='polite'>
                <div className='center-tile__snippet-title'>
                    {this.props.snippetTitle}
                </div>
                {this.getSnippetBlock()}
                <div className='center-tile__url'>
                    <span>Read more at: <a href={this.props.url} title={`Click to read more about ${this.props.snippetTitle}. (Opens a new page.)`}>{this.props.url}</a></span>
                </div>
            </div>
        );
    }
}